import { Component, OnInit, Inject, LOCALE_ID } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { ToastrService } from 'ngx-toastr';
import { Globals } from 'src/app/globals';
import { TranslateService } from '@ngx-translate/core';
import { AcademicsService } from 'src/app/service/academics.service';
import { EnrollmentGroupService } from 'src/app/service/enrollment-group.service';
import { formatDate, DatePipe } from '@angular/common';
@Component({
  selector: 'app-year-update',
  templateUrl: './year-update.component.html',
  styleUrls: ['./year-update.component.scss']
})
export class YearUpdateComponent implements OnInit {

  showLoader: boolean = false;
  updating: boolean = false;
  yearId: any;
  CurrentYear: any;

  updateYear = new FormGroup({
    nameAr: new FormControl('', [
      Validators.required,
    ]),
    nameEn: new FormControl('', [
      Validators.required,
    ]),
    abbriviation: new FormControl('', [
      Validators.required,
    ]),
    startDate: new FormControl('', [
      Validators.required,

    ]),
    endDate: new FormControl('', [
      Validators.required,
    ]),
    days: new FormControl(0, [
      Validators.required,
    ]),

  });

  constructor(
    @Inject(LOCALE_ID) private locale: string,
    private toastrService: ToastrService
    , public globals: Globals, private activatedRoute: ActivatedRoute, private router: Router
    , public translate: TranslateService
    , private academicsService: AcademicsService
    , private datePipe: DatePipe
    , private enrollmentGroupService: EnrollmentGroupService
  ) {

  }

  ngOnInit(): void {
    this.showLoader = true;
    this.activatedRoute
      .queryParams
      .subscribe(params => {
        this.yearId = params['yearId'] || "";

        if (this.yearId != "") {
          this.getYearById();

        } else {
          this.toastrService.warning(this.translate.instant('CAN_NOT_GET_DATA_BE'));
          this.router.navigate(['/academics/calender-day-type']);
        }
      });

    this.updateYear.controls.endDate.valueChanges.subscribe(value => {
      this.getcalendardayscount();
    });
    // this.updateYear.controls.startDate.valueChanges.subscribe(value => {
    //   this.getcalendardayscount();
    // });
  }
  getYearById() {
    this.enrollmentGroupService.getYear(this.yearId).subscribe(
      data => {
        this.updateYear.controls.nameAr.setValue(data.yearDescAr);
        this.updateYear.controls.nameEn.setValue(data.yearDescEn);
        this.updateYear.controls.abbriviation.setValue(data.yearAbrv);
        this.updateYear.controls.days.setValue(data.daysNo);
        this.updateYear.controls.startDate.setValue(data.yearStart);
        this.updateYear.controls.endDate.setValue(data.yearEnd);
        this.showLoader = false;
      },
      () => {
        this.showLoader = false;
        this.toastrService.error(this.translate.instant('CAN_NOT_GET_DATA_BE'));
      }
    );

  }

  updateYearChange() {
  }

  updateYearSubmit() {
    if (this.updateYear.valid) {
      console.log(this.updateYear.value);
      let nameAr = this.updateYear.controls.nameAr.value;
      let nameEn = this.updateYear.controls.nameEn.value;
      let abbriviation = this.updateYear.controls.abbriviation.value;
      let days = this.updateYear.controls.days.value[0];
      // let startDate = this.datePipe.transform(new Date().toLocaleDateString("zh-Hans-CN", { year: 'numeric', month: '2-digit', day: '2-digit' }) + " " + this.updateYear.controls.startDate.value, "yyyy-MM-dd'T'HH:mm:ss.SSS");
      // let endDate = this.datePipe.transform(new Date().toLocaleDateString("zh-Hans-CN", { year: 'numeric', month: '2-digit', day: '2-digit' }) + " " + this.updateYear.controls.endDate.value, "yyyy-MM-dd'T'HH:mm:ss.SSS");
      let startDate = this.updateYear.controls.startDate.value;
      let endDate = this.updateYear.controls.endDate.value;

      this.modifyYear(nameAr, nameEn, abbriviation, days,
        startDate, endDate);
    }
    else {
      this.updateYear.markAllAsTouched();
      this.updateYear.markAsDirty();
    }
  }

  modifyYear(nameAr: string, nameEn: string, abbriviation: string, days: any, startDate: any, endDate: any) {
    this.updating = true;
    let username = this.globals.currentUserInfo.username;
    let orgid = this.globals.orgId;

    this.enrollmentGroupService.updateYear(this.yearId, orgid, username, nameAr, nameEn, abbriviation, startDate, endDate, days)
      .subscribe(
        data => {
          if (data.sts == "SUCCESS") {
            // this.toastrService.success(this.translate.instant('UPDATED_SUCCESSFULLY'));
            if (this.globals.lang == "ar") {
              this.toastrService.success(data.arMsg);
            } else {
              this.toastrService.success(data.enMsg);
            }
            this.router.navigate(['/academics/years']);
          } else if (data.sts == "CAUTION") {
            if (this.globals.lang == "ar") {
              this.toastrService.warning(data.arMsg);
            } else {
              this.toastrService.warning(data.enMsg);
            }
          } else {
            if (this.globals.lang == "ar") {
              this.toastrService.error(data.arMsg);
            } else {
              this.toastrService.error(data.enMsg);
            }

          }
          this.updating = false;
        },
        () => {
          this.updating = false;
          this.toastrService.error(this.translate.instant('CAN_NOT_UPDATE'));
        }
      );
  }




  onItemSelect() {
    // console.log('onItemSelect', item);
  }

  changeactive() {

  }

  getcalendardayscount() {
    console.log('getcalendardayscount');
     this.academicsService.getcalendardayscount(this.globals.orgId,this.updateYear.controls.startDate.value,this.updateYear.controls.endDate.value).subscribe(
       data => {
         //console.log('setting days:'+data);
         this.updateYear.controls.days.setValue(data);
       });
  }
}


